import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import './LoyaltyWallet.css'
import cardSilverLogo from '../../Assets/Icon/card-silver-logo.png'
import cardqrCode from '../../Assets/Icon/qr-code-card.png'
import infoCircle from '../../Assets/Icon/info-circle.png'
import InfoI from '../../Assets/Icon/info-i.png'
import moment from 'moment'
// import WalletPlanPayModal from './WalletPlanPayModal'

const getFormattedFeatures = (features) => {
    try {
      let parsedFeatures;
      if (typeof features === 'string') {
        parsedFeatures = JSON.parse(features || '[]');
      } else {
        parsedFeatures = features || [];
      }

      // If parsedFeatures is an object with numeric keys, convert to array
      if (!Array.isArray(parsedFeatures) && typeof parsedFeatures === 'object' && parsedFeatures !== null) {
        parsedFeatures = Object.values(parsedFeatures);
      }

      // Ensure parsedFeatures is an array
      if (!Array.isArray(parsedFeatures)) {
        console.warn('Parsed features is not an array:', parsedFeatures);
        return ['Points earn and burn'];
      }

      // If array is empty, return default
      if (parsedFeatures.length === 0) {
        return ['Points earn and burn'];
      }

      const formatted = parsedFeatures
        .filter(feature => feature?.type && Number.isFinite(Number(feature.count)) && Number(feature.count) > 0)
        .map(feature => {
          const count = Number(feature.count);
          if (feature.type === 'market_place') {
            return `${count}% Marketplace Discount`;
          }
          if (feature.type === 'royalty_points') {
            return `${count}x Royalty Points`;
          }
          if (feature.type === 'meetup') {
            return `${count} Offline Meeting${count > 1 ? 's' : ''}`;
          }
          const typeName = feature.type
            .replace(/_/g, ' ')
            .replace(/\b\w/g, char => char.toUpperCase());
          return `${count} ${typeName}${count > 1 ? 's' : ''}`;
        })
        .filter(Boolean);

      // console.log('Formatted features:', formatted);
      return formatted.length > 0 ? formatted : ['Points earn and burn'];
    } catch (error) {
      console.error('Error parsing features:', error);
      return ['Points earn and burn'];
    }
  };

const LoyaltyWallet = () => {

    const [getLoading, setLoading] = useState(true);
    const [getPointUsages,setPointUsages] = useState([])
    const [getCurrentPlan,setCurrentPlan] = useState({
        plan: {}
    })
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [loadingMore, setLoadingMore] = useState(false);

    const loadMore = async () => {
        if (currentPage >= totalPages || loadingMore) return;
        setLoadingMore(true);
        try {
            const res = await axios.post(`/api/loyalty-wallet?page=${currentPage + 1}`, {
                "action": "point_usage",
                "item_per_page": 1
            });
            if (res.status === 200) {
                const dataRes = res.data.results.data;
                setPointUsages(prev => [...prev, ...dataRes]);
                setCurrentPage(res.data.results.current_page);
            }
        } catch (error) {
            console.error('Error loading more points:', error);
        } finally {
            setLoadingMore(false);
        }
    };

    useEffect(() => {
        let isMounted = true;

        const fetchInitialData = async () => {
            try {
                const res = await axios.post('/api/loyalty-wallet', {
                    "action": "point_usage",
                    "item_per_page": 5
                });
                if (res.status === 200 && isMounted) {
                    const dataRes = res.data.results.data;
                    setPointUsages(dataRes);
                    setCurrentPage(res.data.results.current_page);
                    setTotalPages(res.data.results.last_page);
                }
            } catch (error) {
                console.error('Error fetching initial points:', error);
            }
        };

        fetchInitialData();

        axios.post('/api/loyalty-wallet',{
            "action": "current_plan",
        }).then((res) => {
            if (isMounted && res.status === 200){
                const dataRes = res.data.results

                setCurrentPlan({...dataRes, formattedFeatures: getFormattedFeatures(dataRes.plan?.features)})

                setLoading(false)
            }
        }).catch(error => {
            console.error('Error fetching current plan:', error);
            if (isMounted) setLoading(false);
        });


        return () => { isMounted = false };
    },[])

    if(getLoading){
        return <>
                    <div>
                        Loading....
                    </div>
                </>
    }


    const getMeterPosition = (plan_title) => {
        console.log(plan_title)
        if(!plan_title){
            return 0
        }
        let title = plan_title.toLowerCase()
        let position = 0
         switch (title) {
             case 'blue':
                 position = 0
                 break;
             case 'silver':
                 position = 60
                 break;
             case 'gold':
                 position = 100
                 break;
             case 'platinum':
                 position = 200
                 break
         }
         return position
     }

     const positionOfMeter =  getMeterPosition(getCurrentPlan.plan?.title)
     console.log(positionOfMeter, getCurrentPlan)

    return (
        <>
            <div>
                <div className="wallet-container">
                    <div className="wallet-card-container">
                        <div className="wallet-plan-card-container">
                            <div className="wallet-plan-card" style={{
                                background: getCurrentPlan.plan?.color
                            }}>
                                <div className="wallet-plan-card-content">
                                    <div className="card-title d-flex justify-content-between">
                                        <div className="card-title-name">
                                            {getCurrentPlan.plan?.title}
                                        </div>
                                        <div className="card-info-icon">
                            
                                                <img className="info-circle" src={infoCircle} alt=""/>
                                                <img className="info-i" src={InfoI} alt=""/>

                                        </div>
                                    </div>

                                    <div className="hss-logo-container">
                                        <img className="hss-logo" src={cardSilverLogo} alt=""/>
                                    </div>
                                    <div className="card-username">
                                        {getCurrentPlan.user?.name}
                                    </div>

                                    {getCurrentPlan?.member_id &&                                     
                                        <div className="card-membershipno">
                                            <span>
                                                Membership: {getCurrentPlan?.member_id ? getCurrentPlan?.member_id : String(getCurrentPlan.id).padStart(6, '0')}
                                            </span>
                                        </div>
                                    }

                                    <div className="card-membershipno">
                                        <span>
                                            Pocket Points: {getCurrentPlan.current_points}
                                        </span>
                                        {/* <span></span> */}
                                    </div>

                                    {getCurrentPlan?.expire_date &&
                                        <div>
                                            Expire Date: {moment(getCurrentPlan?.expire_date).format("LL")}
                                        </div>
                                    }

                                    <div className="card-qrcode-container">
                                        {getCurrentPlan?.qr_code_path && <img src={'https://backend.hellosuperstars.com/' + getCurrentPlan?.qr_code_path} alt="QR" style={{ width: '50%' }} />}
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wallet-card-btn">
                            <Link to="/loyalty-wallet/plan">Upgrade Membership package</Link>
                        </div>
                    </div>

                    <div className="wallet-meter-container">
                        <div className="wallet-status">Your status</div>
                        <div className="wallet-meter">
                            <div class="gauge">
                                <div class="gauge__body">
                                    <div class="gauge__fill" style={{
                                        height: '200%',
                                        width: positionOfMeter + '%'
                                    }}></div>
                                    <div class="gauge__cover"></div>
                                    <div className="info-container">
                                        <div className="info-container-main">
                                            <h1>You are a {getCurrentPlan.plan?.title} Member</h1>
                                            <div className="info-card-container">
                                                <div className="card" style={{
                                                    background: getCurrentPlan.plan?.color
                                                }}>
                                                    <div className="card-name">{getCurrentPlan.plan?.title}</div>
                                                    <img className="mini-hss-logo" src={cardSilverLogo} alt="" height={45} width={45}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="card-bar card-bar-blue">
                                    <span></span>
                                    <span>Blue</span>
                                </div>
                                <div className="card-bar card-bar-silver">
                                    <span></span>
                                    <span>Silver</span>
                                </div>
                                <div className="card-bar card-bar-gold">
                                    <span></span>
                                    <span>Gold</span>
                                </div>
                                <div className="card-bar card-bar-platinum">
                                    <span></span>
                                    <span>Platinum</span>
                                </div>
                            </div>

                            <div className="info-card-more-info">
                                <div className="info-card-reward-points">
                                    <span>{getCurrentPlan.current_points}/</span>{getCurrentPlan.plan?.points_end} pocket points 
                                </div>
                            </div>


                        </div>
                        <div className="card-benefits">
                            <h1>You membership benefits:</h1>
                            <ul>
                            {getCurrentPlan.formattedFeatures.map((txt, idx) => (
                                <li key={`${getCurrentPlan.id}-${idx}`}>{txt.trim()}</li>
                            ))}
                            </ul>
                        </div>
                    </div>


                    <div className="wallet-uses-history">
                        <h1>Your pocket points uses</h1>
                        <div className="wallet-uses-history-list">

                            {getPointUsages.map((item) => {

                                return (
                                    <div key={item.id.toString()}>
                                        <div className="title">{item.use_case}</div>
                                        <div className="timespan d-flex justify-content-between">
                                            <span>
                                                {item.created_at!= null?(
                                                    <>
                                                        <small>{moment(item.created_at).format("LT")}{" | "}</small>
                                                        <small>{moment(item.created_at).format("LL")}</small>
                                                    </>
                                                ):(<>NA</>)}
                                            </span>
                                            <span style={{ fontWeight: 'bold', color: item.usage_type == 'credit'?'green':'red' }}>{item.usage_type=='credit'?'+':'-'}{item.usage_point} points</span>
                                        </div>
                                    </div>
                                )
                            })}

                            {loadingMore && (
                                <div className="loader">Loading more...</div>
                            )}

                        </div>

                        <div className="view-more-btn-container">
                            {currentPage < totalPages ? (
                                <a 
                                    href="javascript:void(0)" 
                                    className="view-more-btn"
                                    onClick={loadMore}
                                >
                                    {loadingMore ? 'Loading...' : 'View More'}
                                </a>
                            ) : (
                                <span>No more points to load</span>
                            )}
                        </div>

                    </div>

                </div>
            </div>
        </>
    )
}

export default LoyaltyWallet